var map = {
	"./assets/Astucia.svg": 8922,
	"./assets/CalibrationSettings.png": 4000,
	"./assets/Chase.svg": 8768,
	"./assets/Feflex.svg": 925,
	"./assets/Flex.svg": 930,
	"./assets/Logo.svg": 3630,
	"./assets/Recurso 10.svg": 3336,
	"./assets/Recurso 11.svg": 3519,
	"./assets/Recurso 12.svg": 2125,
	"./assets/Recurso 13.svg": 8634,
	"./assets/Recurso 14.svg": 5825,
	"./assets/Recurso 15.svg": 8347,
	"./assets/Recurso 16.svg": 1702,
	"./assets/Recurso 3.svg": 6799,
	"./assets/Recurso 5.svg": 1674,
	"./assets/Recurso 6.svg": 707,
	"./assets/Recurso 7.svg": 5674,
	"./assets/Recurso 8.svg": 6430,
	"./assets/Recurso 9.svg": 5272,
	"./assets/Recurso-2.svg": 7164,
	"./assets/Recurso-4.svg": 8148,
	"./assets/Relax Icon.svg": 1468,
	"./assets/Smooth_background_blur_1.jpg": 6196,
	"./assets/Smooth_background_blur_1_gold.png": 3399,
	"./assets/Stamina Challenge.svg": 9484,
	"./assets/TRACKING OPTION 1.png": 9944,
	"./assets/TRACKING OPTION 2.png": 6050,
	"./assets/VERGENCE ICON.png": 6788,
	"./assets/category/Focusing.png": 5626,
	"./assets/category/Focusing.svg": 2926,
	"./assets/category/Synching.png": 7472,
	"./assets/category/Synching.svg": 4278,
	"./assets/category/visionStamina-edited.png": 6672,
	"./assets/elipses.png": 1166,
	"./assets/games/Astucia.svg": 6909,
	"./assets/games/Chase.svg": 1520,
	"./assets/games/Flex.svg": 4006,
	"./assets/games/Reflex.svg": 3532,
	"./assets/games/Relax.svg": 912,
	"./assets/games/StaminaChallenge.svg": 7137,
	"./assets/id.png": 8536,
	"./assets/instructions/Asset-31.svg": 3731,
	"./assets/instructions/Asset-33.svg": 6719,
	"./assets/instructions/Destroyer - Split.svg": 4960,
	"./assets/instructions/Destroyer - left right.svg": 8190,
	"./assets/instructions/Destroyer - pop out.svg": 2597,
	"./assets/instructions/Destroyer - shoot.svg": 7872,
	"./assets/instructions/Diamonds - Arrow keys.svg": 7119,
	"./assets/instructions/Diamonds - Split.svg": 6682,
	"./assets/instructions/Diamonds - pop out.svg": 4854,
	"./assets/instructions/Focusing - Math.svg": 911,
	"./assets/instructions/Focusing - QR.svg": 4062,
	"./assets/instructions/Focusing - Symbols.svg": 2158,
	"./assets/instructions/HammerAlien.svg": 6146,
	"./assets/instructions/Recurso 15.svg": 4130,
	"./assets/instructions/Recurso 16.svg": 7170,
	"./assets/instructions/Recurso-11.svg": 1522,
	"./assets/instructions/Recurso-20.svg": 9062,
	"./assets/instructions/Recurso-27.svg": 1907,
	"./assets/instructions/Recurso-9.svg": 737,
	"./assets/instructions/Ship-Shoot-1.svg": 363,
	"./assets/instructions/Ship-Shoot-2.svg": 1144,
	"./assets/instructions/Smasher - hammer.svg": 892,
	"./assets/instructions/Synching - arrow keys.svg": 9614,
	"./assets/instructions/Synching - moving arrow.svg": 4304,
	"./assets/instructions/accommodationAll_instruction_2.svg": 4573,
	"./assets/instructions/accommodationColor_instruction_3.svg": 5897,
	"./assets/instructions/accommodationCrossfire_instruction_3.svg": 1181,
	"./assets/instructions/accommodationMath_instruction_3.svg": 5040,
	"./assets/instructions/accommodationPicture_instruction_3.svg": 2638,
	"./assets/instructions/accommodationSymbol_instruction_3.svg": 7355,
	"./assets/instructions/all_instruction_1.svg": 8014,
	"./assets/instructions/tracking2_instruction_3.svg": 2562,
	"./assets/instructions/tracking_instruction_2.svg": 7865,
	"./assets/instructions/tracking_instruction_3.svg": 4015,
	"./assets/instructions/tracking_instruction_4.svg": 3666,
	"./assets/instructions/vergence_instruction_2.svg": 4144,
	"./assets/instructions/vergence_instruction_4.svg": 5146,
	"./assets/logo.png": 6949,
	"./assets/visionStamina.png": 7759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;